import React, { useState, useEffect } from 'react';

import { ReactComponent as SlideIcon } from '@assets/icons/order/slide-icon.svg';

const ScrollButtons = ({ className, scrollButtonRef }) => {
	const [arrowDisable, setArrowDisable] = useState(true);
	const [rightArrowDisable, setRightArrowDisable] = useState(false);

	const handleHorizontalScroll = (element, speed, distance, step) => {
		if (!element) return;

		let scrollAmount = 0;
		const slideTimer = setInterval(() => {
			element.scrollLeft += step;
			scrollAmount += Math.abs(step);
			if (scrollAmount >= distance) {
				clearInterval(slideTimer);
			}

			// Update button states during scroll
			updateButtonStates(element);
		}, speed);
	};

	const updateButtonStates = (element) => {
		if (!element) return;

		const isAtStart = element.scrollLeft === 0;
		const isAtEnd = element.scrollLeft + element.clientWidth >= element.scrollWidth - 1;

		setArrowDisable(isAtStart);
		setRightArrowDisable(isAtEnd);
	};

	// Update button states when component mounts or ref changes
	useEffect(() => {
		if (scrollButtonRef?.current) {
			updateButtonStates(scrollButtonRef.current);

			// Add scroll listener to update states
			const handleScroll = () => updateButtonStates(scrollButtonRef.current);
			scrollButtonRef.current.addEventListener('scroll', handleScroll);

			return () => {
				if (scrollButtonRef?.current) {
					scrollButtonRef.current.removeEventListener('scroll', handleScroll);
				}
			};
		}
	}, [scrollButtonRef]);

	const handleLeftClick = () => {
		if (!arrowDisable) {
			handleHorizontalScroll(scrollButtonRef?.current, 10, 70, -220);
		}
	};

	const handleRightClick = () => {
		if (!rightArrowDisable) {
			handleHorizontalScroll(scrollButtonRef?.current, 10, 70, 220);
		}
	};

	return (
		<div className={className ? className : 'scroll-table-buttons'}>
			<button className={`left ${arrowDisable ? 'disabled' : ''}`} onClick={handleLeftClick}>
				<SlideIcon />
			</button>
			&nbsp;&nbsp;{' '}
			<button className={`right ${rightArrowDisable ? 'disabled' : ''}`} onClick={handleRightClick}>
				<SlideIcon />
			</button>
		</div>
	);
};

export default ScrollButtons;
